<!--
    Styles
-->

<style scoped>


    /* main */

    .building {
        align-items: flex-start;
    }
    .building .image {
        flex-shrink: 0;
    }
    .building .content {
        min-width: 0;
    }
    .building .w7 {
        font-size: 135%;
    }


    /* margins */

    .building .image {
        margin-right: 0.75em;
        border-radius: 3px;
    }
    .building .address {
        margin-bottom: 0.4em;
    }
    .building .deal {
        margin-bottom: 0.75em;
    }
    .building .deal:last-child {
        margin-bottom: 0;
    }


    /* image */

    .building.t13 .image {
        width: 102px;
        height: 102px;
    }
    .building.t11 .image {
        width: 86px;
        height: 86px;
    }

</style>



<!--
    Template
-->

<template>
    <div class="building u-row" @mouseenter="hover({building: building.id})" @mouseleave="hover({building: false})">

        <ui-image class="image" ref="image" :src="src" />

        <div class="content u-flex">
            <p class="u-cut w7 cl-blue">{{ building.name }}</p>
            <p class="u-cut address">
                {{ building.address }}
                <span v-if="building.builtAt">, {{ building.builtAt | date }}</span>
            </p>
            <building-deal class="deal" v-for="deal in building.deals" :key="deal.id" :deal="deal" @select="select({deal, building})" />
        </div>

    </div>
</template>



<!--
    Scripts
-->

<script>


    import {mapActions} from 'vuex'
    import maps from '@/common/modules/maps'
    import {date} from '@/common/helpers/parse'
    import uiImage from '@/components/shared/ui/image.vue'
    import buildingDeal from './deal.vue'


    export default {

        filters: {
            date
        },

        components: {
            buildingDeal,
            uiImage
        },

        props: [
            'building'
        ],

        data () {
            return {
                src: null
            }
        },

        methods: {

            ...mapActions('search', [
                'select'
            ]),

            ...mapActions('dashboard', [
                'hover'
            ])

        },

        mounted () {
            this.src = maps.image(this.building, this.$refs.image.$el);
        }

    }

</script>

